import { Link } from 'react-router-dom';

export default function Forbidden() {
    return (
        <div className='min-h-screen flex items-center justify-center bg-slate-100 px-4'>
            <div className='max-w-md w-full rounded-3xl bg-white/80 backdrop-blur border border-slate-200 shadow-xl p-8 text-center space-y-6'>

                <div className='mx-auto w-36 h-36 rounded-full bg-docpgrPurple/10 flex items-center justify-center '>
                    <div className='flex flex-col'>
                        <img src='/assets/voco_logo_condensed_transparent_purple.webp' alt='voco logo'></img>
                        <span className='text-3xl font-bold text-docpgrPurple'>404</span>
                    </div>
                </div>

                <div className='space-y-2'>
                    <h1 className='text-xl font-bold text-slate-800'>
                        page not found
                    </h1>
                    <p className='text-sm text-slate-600'>
                        the page you're looking for doesn't exist or may have been moved
                    </p>
                </div>

                <div className='space-y-3'>
                    <Link to='/dashboard' className='block w-full rounded-lg bg-docpgrPurple px-4 py-2 text-sm font-semibold text-white hover:shadow-docpgr-purple-glow transition'>
                        go to dashboard
                    </Link>
                </div>

                <p className='text-xs text-slate-400'>
                    if you beleive this is an error, please contact support
                </p>
                <p>
                    <a href='mailto:support@docpgr.com' className='text-xs text-docpgrPurple hover:underline'>
                        support@docpgr.com
                    </a>
                </p>

            </div>
        </div>
    )
}